import React, { useEffect, useRef, useState } from "react";
import Breadcrumbs from "components/Common/Breadcrumb";
import { Card, CardBody, Col, Container, Row, Table } from "reactstrap";
import Filters from "components/Common/Filters";
import DataExportDropdown from "components/Shared/DataExportDropdown";
import DownloadCSV from "components/Shared/DownloadCSV";
import DownloadXLSX from "components/Shared/DownloadXLSX";
import TableShimmer from "components/Shared/TableShimmer";
import { pdfDownload } from "helpers/api_helper";
import { EXPORT_DATA } from "helpers/url_helper";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Paginations from "components/Common/Paginations";
import { getAllBranchs } from "store/actions/usersAction";
import { getCountryList } from "store/actions/countriesAction";
import { getAllRegionList } from "store/actions/regionAction";
import { getAllCityList } from "store/actions/cityAction";
import { getLoyaltyPointsReports, getWalletdReports, getGiftcardReports } from "store/actions/reportsAction";
import { groupByForLoyaltyPoints } from "components/Common/constants";
import { getAllCustomersList } from "store/actions/customersAction";
import ReactApexChart from "react-apexcharts";
import { useTranslation } from "react-i18next";
import { getBranchCountryList } from "store/actions/commonAction";

const EidiyahReports = () => {
  const { t, i18n: { language } } = useTranslation();
  document.title = t("Gift Card Reports ");

  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const pageNumber = parseInt(searchParams.get("page")) || 1;
  const [isApiCalled, setIsApiCalled] = useState(false);
  const [customerOptions, setCustomerOptions] = useState([]);
  const { giftCardList } = useSelector((state) => state.GiftCard);
  const { loading, isLoading, totalCount, totalPages, currentPage, itemsPerPage, loyaltyPointsReports, walletReport, giftcardReports } = useSelector((state) => state.Reports);
  const { branchsList, countryList } = useSelector((state) => state.Common);
  const { customersDropdownList } = useSelector((state) => state.Customers);
  const colors = ["#FF4560", "#00E396", "#FEB019", "#008FFB", "#775DD0"];
  const [selectedFilters, setSelectedFilters] = useState({
    branchId: [],
    groupBy: "",
    countryId: [],
    regionId: [],
    cityId: [],
    giftCardId: [],
  });
  const [showGraph, setShowGraph] = useState(false);
  const [isShowGraphBtn, setIsShowGraphBtn] = useState(true);
  const [series, setSeries] = useState([]);
  const [options, setOptions] = useState({
    labels: [],
    colors: colors,
    legend: { show: !1 },
    plotOptions: {
      pie: {
        donut: {
          size: "70%",
        },
      },
    },
  });
  const [dateRange, setDateRange] = useState({});
  const { regionList } = useSelector((state) => state.Region);
  const { cityList } = useSelector((state) => state.City);
  const flatpickrRef = useRef(null);

  useEffect(() => {
    fetchLoyaltyPointsReports();
    fetchBranchCountryList();
  }, []);

  const fetchLoyaltyPointsReports = () => {
    const payload = {
      perPage: itemsPerPage,
      pageNo: pageNumber,
      giftCardId: [],
      dateRange: {},
      groupBy: "giftCard",
    };
    dispatch(getGiftcardReports(payload));
    setIsApiCalled(true);
  };

  const fetchBranchCountryList = () => {
    dispatch(getBranchCountryList());
  };

  const fetchRegionList = (countryId) => {
    dispatch(getAllRegionList(countryId));
  };

  const fetchCityList = (countryId, regionId) => {
    const payload = {
      countryId,
      regionId,
    };
    dispatch(getAllCityList(payload));
  };

  const fetchCustomersList = (keyword) => {
    const payload = {
      keyword,
    };
    dispatch(getAllCustomersList(payload));
  };

  const onInputChange = (value) => {
    value && fetchCustomersList(value);
  };

  useEffect(() => {
    if (giftCardList.length > 0) {
      const updatedCustomerOption = giftCardList?.map((item) => ({
        label: `${item.firstName} ${item.lastName}, ${item?.phoneNumber ? item?.phoneNumber : ""}`,
        value: item._id,
      }));
      setCustomerOptions(updatedCustomerOption);
    }
  }, [giftCardList]);

  const filters = [
    {
      name: "giftCardId",
      type: "multiSelect",
      options: [
        ...customerOptions.map((item) => ({
          label: item.label,
          value: item.value,
        })),
      ],
      placeholder: t("Type To Search Customer"),
    },
  ];

  if (Object.keys(selectedFilters.countryId).length > 0) {
    filters.push({
      name: "regionId",
      type: "singleSelect",
      options: regionList.map((item) => ({
        label: language === "sa" ? item.nameAr : item.name,
        value: item._id,
      })),
      placeholder: t("Select Region"),
    });
  }

  if (Object.keys(selectedFilters.regionId).length > 0) {
    filters.push({
      name: "cityId",
      type: "singleSelect",
      options: cityList.map((item) => ({
        label: language === "sa" ? item.nameAr : item.name,
        value: item._id,
      })),
      placeholder: t("Select City"),
    });
  }

  const handleFilterChange = (selectedValue, filterName) => {
    const value = selectedValue.value;
    setSelectedFilters((prevFilters) => ({
      ...prevFilters,
      [filterName]: selectedValue,
    }));
    if (filterName === "countryId") {
      fetchRegionList(value);
      setSelectedFilters((prev) => ({
        ...prev,
        regionId: [],
        cityId: [],
      }));
    } else if (filterName === "regionId") {
      const { countryId } = selectedFilters;
      fetchCityList(countryId.value, value);
      setSelectedFilters((prev) => ({
        ...prev,
        cityId: [],
      }));
    }
  };

  const handleSearch = () => {
    const { branchId, groupBy, countryId, regionId, cityId, giftCardId } = selectedFilters;
    const customerIds = giftCardId?.map((item) => item.value) || [];

    setShowGraph(false);

    const payload = {
      perPage: itemsPerPage,
      pageNo: 1,
      giftCardId: customerIds,
      groupBy: "giftCard",
      dateRange: { min: dateRange.min, max: dateRange.max },
    };

    dispatch(getGiftcardReports(payload))
      .then((action) => {
        const { statusCode, status, msg } = action?.payload;
        if (statusCode === 200 && status) {
          navigate(`/giftcard-reports?page=${1}`);
        }
      })
      .catch((error) => {});
  };

  const handleReset = () => {
    const payload = {
      perPage: itemsPerPage,
      pageNo: pageNumber,
      giftCardId: [],
      groupBy: "giftCard",
      dateRange: {},
    };
    dispatch(getGiftcardReports(payload));
    navigate(`/giftcard-reports?page=${1}`);
    setSelectedFilters({
      branchId: [],
      groupBy: "",
      cityId: [],
      regionId: [],
      countryId: [],
      giftCardId: [],
    });
    setDateRange({});
    if (flatpickrRef.current) {
      flatpickrRef.current.flatpickr.clear();
    }
  };

  const onPageChange = (page) => {
    const { branchId, groupBy, countryId, regionId, cityId, giftCardId } = selectedFilters;
    const customerIds = giftCardId?.map((item) => item.value) || [];

    const payload = {
      perPage: itemsPerPage,
      pageNo: page,
      giftCardId: customerIds,
      groupBy: "giftCard",
      dateRange: { min: dateRange.min, max: dateRange.max },
    };

    dispatch(getGiftcardReports(payload));
    navigate(`/giftcard-reports?page=${page}`);
  };

  const exportToCSV = async () => {
    const { branchId, groupBy, countryId, regionId, cityId, giftCardId } = selectedFilters;
    const customerIds = giftCardId?.map((item) => item.value) || [];

    const payload = {
      type: "REPORT-GIFT-CARD",
      exportType: "csv",
      giftCardId: customerIds,
      dateRange: { min: dateRange.min, max: dateRange.max },
    };

    const response = await pdfDownload(EXPORT_DATA, payload);
    if (response) {
      const csvData = response;
      DownloadCSV(csvData, t("Gift Card Reports"));
    }
  };

  const handleExcelDownload = async () => {
    const { branchId, groupBy, countryId, regionId, cityId, giftCardId } = selectedFilters;
    const customerIds = giftCardId?.map((item) => item.value) || [];

    const payload = {
      type: "REPORT-GIFT-CARD",
      exportType: "xlsx",
      giftCardId: customerIds,
      dateRange: { min: dateRange.min, max: dateRange.max },
    };

    const response = await pdfDownload(EXPORT_DATA, payload);
    if (response) {
      const xlsxData = response;
      DownloadXLSX(xlsxData, t("Gift Card Reports"));
    }
  };

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs />
        <Row>
          {showGraph && (
            <Col xl={12}>
              <Card>
                <CardBody>
                  <h4 className="card-title mb-4">
                    {t("Gift Card Report Chart")}
                  </h4>
                  <Row>
                    <Col lg={6}>
                      <div>
                        <div id="donut-chart">
                          <ReactApexChart
                            options={options}
                            series={series}
                            type="donut"
                            height={260}
                            className="apex-charts"
                          />
                        </div>
                      </div>
                    </Col>
                    <Col lg={6}>
                      <div className="row text-muted">
                        {giftcardReports[0] &&
                          Object.entries(giftcardReports[0])
                            ?.filter(([key]) => key !== "loyaltyPointsIssued")
                            ?.map(([key, value], index) => (
                              <div className="col-6 mt-4" key={key}>
                                <p className="mb-2 text-truncate">
                                  <i
                                    className={`mdi mdi-circle  me-1`}
                                    style={{ color: colors[index % colors.length] }}
                                  />{" "}
                                  {t(key)}
                                </p>
                                <h5>{value}</h5>
                              </div>
                            ))}
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          )}
          <Col xl={12}>
            <Card>
              <DataExportDropdown
                cardTitle={t("Gift Card Reports")}
                isAddBtn={loading ? false : isShowGraphBtn}
                addBtnText={`${showGraph ? t("Hide") : t("Show")} ${t("Graph")}`}
                onAddBtnClick={() => setShowGraph(!showGraph)}
                onDownloadCSV={exportToCSV}
                onDownloadExcel={handleExcelDownload}
                isExportData={loading ? false : true}
              />
              <CardBody>
                <Filters
                  filters={filters}
                  hideSearch={true}
                  handleFilterChange={handleFilterChange}
                  handleSearch={handleSearch}
                  onReset={handleReset}
                  selectedFilters={selectedFilters}
                  isRangeDate={true}
                  dateRange={dateRange}
                  flatpickrRef={flatpickrRef}
                  onInputChange={onInputChange}
                  setDateRange={setDateRange}
                  colSize={4}
                />
                <div className="table-responsive">
                  {loading ? (
                    <TableShimmer row={7} col={5} />
                  ) : giftcardReports.length === 0 ? (
                    <p className="text-center my-5 py-3">
                      {t("No gift card report found")}
                    </p>
                  ) : (
                    <Table className="table mb-0" hover>
                      <thead className="table-light full_th">
                        <tr>
                          {["Name", "Purchased Count", "Redeemed Amount", "Total Amount"].map((column, index) => (
                            <th key={index}>{t(column)}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {giftcardReports?.map((item, index) => (
                          <tr key={index}>
                            {["name", "purchasedCount", "redeemedAmount", "totalAmount"].map((column, colIndex) => (
                              <td key={colIndex}>{item[column] || "-"}</td>
                            ))}
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  )}
                </div>
                {!loading && giftcardReports.length > 0 && (
                  <div className="mt-3">
                    <Paginations
                      totalCount={totalCount}
                      totalPages={totalPages}
                      currentPage={currentPage}
                      onPageChange={onPageChange}
                    />
                  </div>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default EidiyahReports;
